import x from "@mui/icons-material/Add";
import { styled as t, Box as n, Typography as l } from "@mui/material";
import c from "../../temp-lib/components/share/apeiron/ApeironLinkButton.js";
import f from "./LevelContainer.js";
import g from "./LevelProgressBar.js";
import * as p from "ramda";
import { jsxs as r, jsx as o } from "react/jsx-runtime";
const u = t(c)`
  background: #8f8f8f;
  min-width: unset;
  min-height: unset;
  ${(e) => e.theme.breakpoints.up("res768")} {
    border-radius: 8px;
    height: 36px;
    width: 36px;
  }
  ${(e) => e.theme.breakpoints.down("res768")} {
    border-radius: 4px;
    height: 24px;
    width: 24px;
  }
`, b = t(n)`
  align-items: center;
  display: flex;
  ${(e) => e.theme.breakpoints.up("res768")} {
    padding: 0 20px;
    column-gap: 10px;
  }
  ${(e) => e.theme.breakpoints.down("res768")} {
    padding: 0 10px;
    column-gap: 4px;
  }
`, k = t(f)`
  ${(e) => e.theme.breakpoints.down("res768")} {
    width: 40px;
    height: 40px;
  }
`, w = t(l)`
  color: #c2abf6;
  font-weight: 500;
  ${(e) => e.theme.breakpoints.up("res768")} {
    font-size: 56px;
  }
  ${(e) => e.theme.breakpoints.down("res768")} {
    font-size: 28px;
  }
`, $ = t(l)`
  font-weight: 400;
  ${(e) => e.theme.breakpoints.up("res768")} {
    font-size: 20px;
  }
  ${(e) => e.theme.breakpoints.down("res768")} {
    font-size: 12px;
  }
`, y = t(n)`
  flex-grow: 1;
`, L = t(n)`
  align-items: center;
  column-gap: 10px;
  display: flex;
`, T = ({
  className: e,
  level: a,
  levelTitle: d,
  nextLevelPoint: h,
  progress: m,
  urlAdd: i,
  onAddClick: s
}) => /* @__PURE__ */ r(b, {
  className: e,
  children: [/* @__PURE__ */ o(k, {
    children: /* @__PURE__ */ o(w, {
      children: a
    })
  }), /* @__PURE__ */ r(y, {
    children: [/* @__PURE__ */ o($, {
      children: d
    }), /* @__PURE__ */ r(L, {
      children: [/* @__PURE__ */ o(g, {
        progress: m,
        nextLevelPoint: h
      }), p.isNotNil(i) || p.isNotNil(s) ? /* @__PURE__ */ o(u, {
        url: i,
        target: "_blank",
        onClick: s,
        children: /* @__PURE__ */ o(x, {})
      }) : null]
    })]
  })]
});
export {
  T as default
};
//# sourceMappingURL=LevelProgressDisplay.js.map
